export const CSS_MOBILE_LAYOUT_WIDTH = 1024;
export const CSS_MOBILE_CONFIGURATOR_HEIGHT = 270;
export const CSS_DESKTOP_CAMERA_MAX_HEIGHT = 450;
export const IMAGE_RATIO_169 = "169";
export const IMAGE_RATIO_34 = "34";
export const MODULE_CAMERA_MAX_HEIGHT = 900;
export const MODULE_CAMERA_MIN_HEIGHT = 300;
export const MODULE_CAMERA_MIN_WIDTH = 300;
export const MODULE_CAMERA_MAX_WIDTH = 600;
export const SCENE7_DEFAULT_RESOLUTION = 1080;
export const SCENE7_RESOLUTION_RANGES = [720, 1080, 1440, 2160];
